import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const menuData = {
  kurumsal: {
    title: 'Kurumsal',
    description: 'EMUR INNOVATION hakkında her şey',
    items: [
      { title: 'Hakkımızda', desc: 'Vizyonumuz, misyonumuz ve değerlerimiz', path: '/hakkimizda', icon: '🏢' },
      { title: 'Neden EMUR', desc: 'Bizi tercih etmeniz için nedenler', path: '/neden-emur', icon: '⭐' },
      { title: 'Bilgi Güvenliği Politikamız', desc: 'ISO 27001 sertifikalı güvenlik politikası', path: '/bilgi-guvenligi', icon: '🔒' },
      { title: 'İş Ortaklarımız', desc: 'Global teknoloji iş ortaklıklarımız', path: '/is-ortaklarimiz', icon: '🤝' },
      { title: 'Referanslarımız', desc: 'Güvenen kurum ve kuruluşlar', path: '/referanslarimiz', icon: '📊' },
      { title: 'Başarı Hikayeleri', desc: 'Müşterilerimizin başarı öyküleri', path: '/basari-hikayeleri', icon: '🏆' },
      { title: 'İnsan Kaynakları', desc: 'Kariyerinizi bizimle geliştirin', path: '/insan-kaynaklari', icon: '👥' },
      { title: 'Basında Biz', desc: 'Medyada EMUR INNOVATION', path: '/basinda-biz', icon: '📰' },
    ]
  },
  cozumler: {
    title: 'Yenilikçi Çözümler',
    description: 'İşletmenize özel bulut ve BT çözümleri',
    items: [
      { title: 'Siber Güvenlik', desc: 'Buluttaki güvenliğinizi artırın', path: '/cozumler/guvenlik', icon: '🛡️' },
      { title: 'Network Çözümleri', desc: 'Yönetilebilir ağ altyapıları', path: '/cozumler/network', icon: '🌐' },
      { title: 'Veri Merkezi', desc: 'Esnek ve güvenli veri merkezi', path: '/cozumler/veri-merkezi', icon: '🖥️' },
      { title: 'Yedekleme & Arşivleme', desc: 'Verileriniz güvende', path: '/cozumler/yedekleme', icon: '💾' },
      { title: 'Mail Çözümleri', desc: 'Kurumsal e-posta hizmetleri', path: '/cozumler/mail', icon: '📧' },
      { title: 'Startup Çözümleri', desc: 'Startup\'lar için özel paketler', path: '/cozumler/startup', icon: '🚀' },
      { title: 'Geliştirme & Test', desc: 'DevOps ve test ortamları', path: '/cozumler/gelistirme-test', icon: '🧪' },
      { title: 'KVKK Danışmanlığı', desc: 'Tam uyumluluk çözümleri', path: '/cozumler/kvkk', icon: '📋' },
    ]
  },
  hizmetler: {
    title: 'Hizmetlerimiz',
    description: 'Kapsamlı bulut ve BT hizmet portföyümüz',
    items: [
      { title: 'Bulut Hizmetleri', desc: 'Ölçeklenebilir cloud altyapısı', path: '/hizmetler/bulut', icon: '☁️' },
      { title: 'Dijital Dönüşüm', desc: 'Uçtan uca dijital dönüşüm', path: '/hizmetler/dijital-donusum', icon: '🔄' },
      { title: 'EmurOne', desc: 'Tek platform, tüm hizmetler', path: '/hizmetler/emurone', icon: '📦' },
      { title: 'HPC', desc: 'Yüksek performanslı bilgi işlem', path: '/hizmetler/hpc', icon: '⚡' },
      { title: 'Dış Kaynak (Outsource IT)', desc: 'BT dış kaynak hizmetleri', path: '/hizmetler/dis-kaynak', icon: '🔧' },
      { title: 'Özel Bulut Sunucu', desc: 'Dedicated cloud sunucular', path: '/hizmetler/ozel-bulut', icon: '🖧' },
      { title: 'Felaket Kurtarma', desc: 'İş sürekliliği çözümleri', path: '/hizmetler/felaket-kurtarma', icon: '🔁' },
      { title: 'Danışmanlık Hizmetleri', desc: 'Uzman BT danışmanlığı', path: '/hizmetler/danismanlik', icon: '💼' },
    ]
  }
};

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setOpenSubmenu(null);
  }, [location]);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      {/* Top Bar */}
      <div className="header-top">
        <div className="container">
          <div className="header-top-left">
            <a href="mailto:info@emurinnovation.com">✉️ info@emurinnovation.com</a>
          </div>
          <div className="header-top-right">
            <Link to="/destek">Destek Merkezi</Link>
            <Link to="/giris">Giriş</Link>
            <Link to="/kayit" className="btn-register">Kayıt</Link>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="header-main">
        <div className="container">
          <Link to="/" className="logo">
            <div className="logo-icon">E</div>
            <div className="logo-text">
              <span className="brand">EMUR <span>INNOVATION</span></span>
              <span className="tagline">Cloud Solutions</span>
            </div>
          </Link>

          <nav className={`nav-menu ${mobileOpen ? 'open' : ''}`}>
            <div className="nav-item">
              <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>
                Anasayfa
              </Link>
            </div>

            {Object.entries(menuData).map(([key, menu]) => (
              <div
                className={`nav-item ${openSubmenu === key ? 'open' : ''}`}
                key={key}
                onClick={() => setOpenSubmenu(openSubmenu === key ? null : key)}
              >
                <span className="nav-link">
                  {key === 'kurumsal' ? 'Kurumsal' : key === 'cozumler' ? 'Çözümler' : 'Hizmetler'}
                  <span className="nav-arrow">▼</span>
                </span>
                <div className="mega-menu">
                  <div className="mega-menu-header">
                    <h3>{menu.title}</h3>
                    <p>{menu.description}</p>
                  </div>
                  <div className="mega-menu-grid">
                    {menu.items.map((item, idx) => (
                      <Link to={item.path} className="mega-menu-item" key={idx}>
                        <div className="item-icon">{item.icon}</div>
                        <div className="item-content">
                          <h4>{item.title}</h4>
                          <p>{item.desc}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            ))}

            <div className="nav-item">
              <Link to="/referanslarimiz" className="nav-link">Referanslar</Link>
            </div>
            <div className="nav-item">
              <Link to="/iletisim" className={`nav-link ${location.pathname === '/iletisim' ? 'active' : ''}`}>
                İletişim
              </Link>
            </div>
          </nav>

          <div className="mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
            <span style={mobileOpen ? { transform: 'rotate(45deg) translate(5px, 5px)' } : {}} />
            <span style={mobileOpen ? { opacity: 0 } : {}} />
            <span style={mobileOpen ? { transform: 'rotate(-45deg) translate(5px, -5px)' } : {}} />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
